import React, { useMemo } from 'react';
import { useOutletContext } from 'react-router';

import { StatisticOutletContextType } from '../type';

import StatisticWidgetBlock from './statistic-widget-block';
const StatisticWidgetBlockMemo = React.memo(StatisticWidgetBlock);
const QmStatisticMainWidgets = () => {
  // const { t } = useTranslation('pages.qmManage.statistic.widget');

  const { widgetsList } = useOutletContext<StatisticOutletContextType>();
  const widgetIds = useMemo(() => widgetsList?.widgets.map((w) => w.mfs.id), [widgetsList]);
  return (
    <div className="flex flex-col gap-[20px]">
      {widgetsList?.widgets.map((widget) => (
        <StatisticWidgetBlockMemo
          key={widget.mfs.id}
          widgetsList={widgetIds}
          mform_id={widget.mfs.id}
          widgetData={widget}
        />
      ))}
    </div>
  );
};

export default QmStatisticMainWidgets;
